<template>
    <div>
       
        <div class="row">
            <div class="col-sm-1">
                <v-card class="drawer-bar mx-auto" width="100%" height="100vh"
                    style="position: fixed;background: #f8f8fb !important; width: 250px !important;">
                    <v-navigation-drawer permanent  style="z-index: 5;position: fixed;">
                        <Sidebar :itemsMenu="itemsMenu" />
                    </v-navigation-drawer>
                    <NavBar @updateNavBar="updateNavBar" style="position: fixed;z-index: 0;width: 100%;height: 4rem !important;width: 296px  !important;" />
                </v-card>
            </div>
            <v-navigation-drawer v-model="drawerBar" absolute temporary @input="updateDrawerState"
                style="padding-top: 5rem;background: #f8f8fb !important;">
                <Sidebar :itemsMenu="itemsMenu" />
            </v-navigation-drawer>
            <div class="main-responsive"
                style="width: 100%; padding-right: 1.5rem; margin-top: 3rem;background: #f8f8fb !important;">
                <router-view></router-view>
            </div>
            <v-overlay :z-index="zIndex" :value="overlay">
                <v-card elevation="2" shaped class="mx-auto my-5 elevation-1">
                    <v-row class="fill-height">
                        <v-col>
                            Usuario Inhabilitado
                        </v-col>
                    </v-row>
                </v-card>
            </v-overlay>
        </div>
    </div>
</template>
<style scoped>
::v-deep .v-icon.notranslate.fas.fa-chevron-down.theme--light{
    font-size: 0.9rem !important;
}
::v-deep .svg-inline--fa.fa-chevron-down.notranslate.theme--light.v-icon{
    font-size: 0.9rem !important;
} 
.v-navigation-drawer {
    width: 280px  !important;
    box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.618);
}

::v-deep .el-form-item__label {
    margin-left: .2rem !important;
    line-height: 0px !important;
}
.v-icon.v-icon {
    color: rgb(255, 255, 255) !important
}

.theme--light.v-icon {
    color: rgb(255, 255, 255) !important;
}

a {
    text-decoration: none;
}

.v-divider.theme--light {
    border-color: rgba(255, 255, 255, 0.643);
}

a:hover {
    background-color: #ffffff10;
}

.v-list-item__title.text-h6,
.v-list-item__subtitle {
    color: white !important;
    text-decoration: none;
}

.v-list-item-navbar:hover {
    background-color: #ffffff10;
}

.v-list-item-navbar {
    margin: 0.5rem 0;
}

.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
    color: white !important;
    text-decoration: none;
}

.v-list-group {
    color: white !important;
}

.v-list-group__header :hover {
    background-color: #ffffff10;
}

.v-navigation-drawer {
    background: linear-gradient(135deg, #005dbe, #0062be, #005dc6) !important;
    color: white !important;
}
::v-deep.v-list-item--dense, .v-list--dense .v-list-item {
    height: 200px;
}
.main-responsive {
    padding-left: 22rem;
}

@media (max-width: 1024px) {
    .main-responsive {
        margin-left: 0rem;
        padding-left: 1.5rem;
    }
}

tbody tr td {
    font-size: 0.7rem;
}

.v-expansion-panel-header {
    padding: 0.5rem !important;
}

@media (max-width: 1024px) {
    .drawer-bar {
        display: none;
    }
}

/* Opcional: Mostrar el botón solo en pantallas mayores a 1024px (ej. desktops) */
@media (min-width: 1024px) {
    .drawer-bar {
        display: block;
    }
}

::v-deep .el-dialog,
.el-form,
.el-input,
.el-button,
.el-date-picker,
.el-table,.el-picker-panel__body {
  /* /*  font-family: 'Poppins', sans-serif !important; */
  font-family: "Roboto", sans-serif !important;
}
</style>
<script>
import NavBar from "../../../components/navbar/NavBar.vue";
import NavBarClinicas from "../../../components/navbar/NavBarClinicas.vue";
import Sidebar from "../../../components/sidebar/sidebar.vue";
import { mapState, mapActions } from "vuex";
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export const API_KEY_DNI = process.env.VUE_API_KEY_DNI;

export default {
    data() {
        return {
            overlay: false,
            zIndex: 99,
            perfil: "",
            nombre: "",
            itemsMenu: [],
            idUsuario: null,
            system: "RRHH Planilla",
            idSystem:null
        };
    },
    methods: {
        getIdSytem(){
            axios
                .get(RUTA_API + "/seguridad_system/obtener-id/?system=" + this.system)
                .then((res) => {
                    this.idSystem=res.data[0].id;
                    sessionStorage.setItem("idSystem", this.idSystem);
                    this.loadComponentes();
                })
                .catch((res) => {
                });
        },
        loadComponentes() {
            axios
                .get(RUTA_API + "/seguridad_usuario/buscar-usuario/?usuario=" + this.idUsuario+"&system="+ this.idSystem)
                .then((res) => {
                    if (res.data.estado == false) {
                        this.overlay = true;
                    }
                    const lista = res.data[0].componentes;
                    this.itemsMenu = this.estructurarComponentes(lista);
                    sessionStorage.setItem("correoAuditorioUsuario", res.data.correo);
                    sessionStorage.setItem("idUsuarioAuditorio", res.data.id);
                    sessionStorage.setItem("usuarioArea", res.data.area);
                })
                .catch((res) => {
                });
        },
        estructurarComponentes(lista) {
            const mapa = {}; // Almacena los elementos por su ID
            const resultado = []; // Lista final con estructura jerárquica

            // Primero, se asignan los elementos al mapa usando su ID
            lista.forEach(item => {
                mapa[item.id] = { ...item, children: [] };
            });

            // Luego, se organizan en jerarquía según `padre_id`
            lista.forEach(item => {
                if (item.padre_id === 0) {
                    resultado.push(mapa[item.id]); // Es un nodo raíz
                } else if (mapa[item.padre_id]) {
                    mapa[item.padre_id].children.push(mapa[item.id]); // Se añade como hijo del padre
                }
            });

            // Remover `hijos` en elementos que no tengan hijos
            function limpiarHijos(obj) {
                if (obj.children.length === 0) {
                    delete obj.children; // Elimina el array si está vacío
                } else {
                    obj.children.forEach(limpiarHijos); // Llamada recursiva para limpiar los hijos
                }
            }
            resultado.forEach(limpiarHijos);

            return resultado;
        },
        updateNavBar(datos) {
            this.drawerBar = datos;
        },
        ...mapActions(["setDrawerBar"]),
        handleRouteChange() {
            this.setDrawerBar(false);
        },
        updateDrawerState(value) {
            this.setDrawerBar(value);
        },
    },
    computed: {
        ...mapState(["drawerBar"]),
    },
    mounted() { 
        this.getIdSytem();
    },
    created() {
        this.perfil = sessionStorage.getItem("perfil");
        this.nombre = sessionStorage.getItem("nombre");
        this.idUsuario = sessionStorage.getItem("idUsuario");
        /* this.loadComponentes(); */
        this.$router.afterEach(() => {
            this.handleRouteChange();
        });
    },
    components: {
        NavBar,
        NavBarClinicas,
        Sidebar
    },
};
</script>